export const STATES = {
	INIT: "INIT",
	READY: "READY",
	LOADED: "LOADED",
	PREINFO: "PREINFO",
	SOUND: "SOUND",
	IDLE: "IDLE",
	FS_IDLE: "FS_IDLE",
	SPIN: "SPIN",
	SKIP: "SKIP",
	BONUS: "BONUS", //mystery, saloon...
	BONUS_WHEEL: "BONUS_WHEEL", // cheeser
	FORCESPIN: "FORCESPIN",
	BONUS_WIN: "BONUS_WIN",
	SEARCHING: "SEARCHING",
	ERROR: "ERROR",
	JOKER_BONUS_WIN: "JOKER_BONUS_WIN",
};
